import { useState } from 'react';
import { OrgChart } from '../components/OrgChart';
import { OrganizationUnitFormDialog } from '../components/OrganizationUnitFormDialog';
import { FeatureErrorBoundary } from '@/core/error-boundaries/public';
import { sentryReporter } from '@/core/observability/public';

export default function OrganizationUnitsPage() {
  const [formOpen, setFormOpen] = useState(false);

  const handleCreate = () => {
    setFormOpen(true);
  };

  return (
    <FeatureErrorBoundary reporter={sentryReporter}>
      <div className="flex h-[calc(100dvh-6rem)] flex-col">
        <OrgChart onCreateArea={handleCreate} />
        <OrganizationUnitFormDialog open={formOpen} onOpenChange={setFormOpen} />
      </div>
    </FeatureErrorBoundary>
  );
}
